<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' Ayar işlemleri için, '" v-model="loadingvmodel"></loadingcomp>
    <v-app id="inspire" light>
      <v-card height="100%" color="grey lighten-3" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ $t('Additional-Products') }} </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-flex>
          <v-layout row wrap>
            <v-flex xs8 pa-1 sm12 md9>
              <v-flex xs12 sm12 md12>
                <v-card flat="">
                  <v-layout pa-2 row wrap>
                    <v-flex xs12 pt-2 pb-2 sm12 md12>
                      <v-icon medium="" color="info">widgets</v-icon>&nbsp;
                      <span class="font-weight-regular grey--text title"> {{ $t('Product-Type-Selection') }} </span>
                      <v-divider></v-divider>
                    </v-flex>
                    <v-flex @click="duzenle(item)" pa-1 v-for="item in ekurunitems" v-show="item.Aktif==true"
                      v-bind:key="item.id" xs12 sm6 md4>
                      <v-hover>
                        <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 8 : 2}`" class="mx-auto">
                          <v-card-title>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-card flat class="black--text">
                                  <v-card flat="">
                                    <v-card-actions>
                                      <v-layout row wrap>
                                        <v-flex xs12 sm12 md2>
                                          <v-layout align-center="" justify-start="" fill-height="">
                                            <v-icon large="" color="grey">widgets</v-icon>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs12 pa-2 sm1 md1>
                                          <v-layout align-center="" justify-start="" fill-height="">
                                            <v-divider vertical></v-divider>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs12 pa-1 sm12 md8>
                                          <v-layout align-center="" justify-start="" fill-height=""><span
                                              class="title grey--text font-weight-regular">
                                              {{ item.EkUrunGrupAdi  }}

                                            </span></v-layout>
                                        </v-flex>
                                        <v-flex xs4 sm4 md1>
                                          <v-layout align-center="" justify-end="" fill-height=""><span
                                              class="body-1 font-weight-thin">
                                              <v-icon v-if="aktifgrup==item.EkUrunGrupID" large=""
                                                @click="duzenle(item)" color="green">check_circle</v-icon>
                                              <v-icon v-if="aktifgrup!=item.EkUrunGrupID" large @click="duzenle(item)"
                                                color="grey">radio_button_unchecked</v-icon>
                                            </span></v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-actions>
                                  </v-card>
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-card-title>
                        </v-card>
                      </v-hover>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 pt-2 v-if="aktifgrup!= null" sm12 md12>
                <v-card flat="">
                  <v-layout pa-2 row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-icon medium="" color="info">shopping_cart</v-icon>&nbsp;
                      <span class=" font-weight-regular grey--text title">{{$t('Select-Product')}}</span>
                      <v-divider></v-divider>
                    </v-flex>
                    <v-flex pa-1 v-for="item in urunler" v-bind:key="item.id" xs12 sm12 md12>
                      <v-hover>
                        <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 0 : 0}`" class="mx-auto">
                          <v-card-title>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-card flat class="black--text">
                                  <v-card flat="">
                                    <v-card-actions>
                                      <v-layout row wrap>
                                        <v-flex pa-2 xs12 sm4 md2>
                                          <v-layout row wrap>
                                            <v-flex xs12 sm12 md12>
                                              <div class="text-xs-center"><img height="50%" width="50%"
                                                src="../../../assets/images/arkman.png"  alt="Arkman"></div>
                                            </v-flex>
                                            <v-flex pa-2 xs12 sm12 md12>
                                              <v-layout justify-center="" row wrap><span
                                                  class="title grey--text font-weight-regular">
                                                  {{ item.EkUrunAdi }}
                                                </span></v-layout>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs1 sm1 md1>
                                          <v-layout align-center="" justify-center="" fill-height="">
                                            <v-divider vertical></v-divider>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs12 pt-3 pb-3 sm12 md7>
                                          <v-layout align-start="" justify-start="" fill-height=""><span
                                              class="title grey--text font-weight-"> {{item.EkUrunAciklama}}

                                            </span></v-layout>
                                        </v-flex>
                                        <v-flex xs4 pa-2 xs12 sm12 md2>
                                          <v-layout align-center="" justify-center="" fill-height="">

                                            <v-layout row wrap justify-center="">
                                              <v-flex v-if="!getdegeral(item)" xs12 sm12 md12>
                                                <v-layout justify-center=""><span
                                                    class="display-1 grey--text font-weight-">
                                                    {{ item.Tutar | moneyformat }}{{getparabirimi()}}


                                                  </span></v-layout>
                                              </v-flex>
                                              <v-flex v-if="!getdegeral(item)" xs12 sm12 md12>
                                                <v-divider></v-divider>
                                              </v-flex>
                                              <v-flex v-if="!getdegeral(item)" pt-1 xs12 sm12 md12>
                                                <v-layout justify-center=""><span class="subheading grey--text ">
                                                  {{$t('totalamount')}} </span></v-layout>
                                              </v-flex>
                                              <v-flex xs12 sm12 pt-2 md12>
                                                <v-layout justify-center="">
                                                  <v-btn v-if="!getdegeral(item)" @click="sepeteEkle(item)" outline=""
                                                    color="info">
                                                    <v-icon>add_shopping_cart</v-icon>&nbsp;
                                                    {{ $t('Add-to-Basket') }}
                                                  </v-btn>
                                                  <v-chip v-if="getdegeral(item)" large color="green"
                                                    text-color="white">
                                                    <v-avatar>
                                                      <v-icon color="white">check_circle</v-icon>
                                                    </v-avatar> {{$t('Product-Already-Purchased')}}
                                                  </v-chip>
                                                </v-layout>
                                              </v-flex>
                                            </v-layout>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-actions>
                                  </v-card>
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-card-title>
                        </v-card>
                      </v-hover>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 pt-2 v-if="aktifgrup!= null" sm12 md12>
                <v-card flat="">
                  <v-layout pa-2 row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-icon medium="" color="info">beenhere</v-icon>&nbsp;

                      <span class=" font-weight-regular grey--text title">{{$t('Contracted-Integrators')}}</span>
                      <v-divider></v-divider>
                    </v-flex>
                    <v-flex pa-1 v-show="aktifgrup==item.Tip " v-for="item in entegratorler" v-bind:key="item.id" xs12
                      sm12 md3>
                      <v-hover>
                        <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 0 : 0}`" class="mx-auto">
                          <v-card-title>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-card flat class="black--text">
                                  <v-card flat="">
                                    <v-card-actions>
                                      <v-layout row wrap>
                                        <v-flex pa-2 xs12 sm4 md12>
                                          <v-layout row wrap>
                                            <v-flex xs12 sm12 md12>
                                              <v-layout align-center="" row wrap justify-center=""><img height="60px"
                                                  width="100px" :src="item.imgLink" alt="Arkman">
                                                <div v-if="item.name==aktifEntegrator" class="kurdele-alani">
                                                  <div class="kurdele">{{ $t('Active') }}</div>
                                                </div>
                                                <div v-if="item.name=='airarabiapazar' || item.name=='airtuerkpazar' || item.name=='easygdspazar'" class="kurdele-alani">
                                                  <div class="kurdele">{{ 'Yakında' }}</div>
                                                </div>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex pa-2 xs12 sm12 md12>
                                              <v-layout justify-center="" row wrap><span
                                                  class="title grey--text font-weight-regular"> {{item.urunAdi}}

                                                </span></v-layout>
                                            </v-flex>
                                            <v-flex pa-2 xs12 sm12 md12>
                                              <v-layout justify-center="" row wrap>
                                                <v-btn @click="entegratorAyarla(item,aktifgrup)" outline="" color="info"
                                                  block="">
                                                  <v-icon>settings</v-icon> {{$t('Settings')}}
                                                </v-btn>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-actions>
                                  </v-card>
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-card-title>
                        </v-card>
                      </v-hover>
                    </v-flex>
                   
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 pt-2 v-if="entegratorShow" sm12 md12>
                <v-card flat="">
                  <v-layout pa-2 row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-icon medium="" color="info">settings</v-icon>&nbsp;
                      <span class=" font-weight-regular grey--text title">{{$t('Integrator-Settings')}}</span>
                      <v-divider></v-divider>
                    </v-flex>
                    <v-flex pa-1 xs12 sm12 md12>
                      <v-text-field v-for="(value, key) in entegratorAyar" :label="key" :key="key.id"
                        v-model="entegratorAyar[key]" hide-details v-if="key=='Password' || key=='UserName' || key=='Department' || key=='ArkmanPassword' || key=='VKN'"></v-text-field>
                    </v-flex>
                    <v-flex pa-1 xs12 sm12 md12>
                      <v-layout justify-end="" row wrap>
                        <v-btn outline="" @click="entegratorAyarKaydet()" color="info">
                          <v-icon>save</v-icon>&nbsp;
                          {{ $t('Save-Settings') }}
                        </v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 sm12 md12 pt-2 v-if="serviceShow">
               <v-card>
                  <v-text-field
                    v-model="serviceData.UserName"
                    label="Kullanıcı Adı"
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                  ></v-text-field>
                   <v-text-field
                    v-model="serviceData.Password"
                    label="Şifre"
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    :type="show1 ? 'text' : 'password'"
                  ></v-text-field>
                  <v-text-field
                    v-model="serviceData.Url"
                    label="Url"
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    :type="show1 ? 'text' : 'password'"
                  ></v-text-field>
                  
                  <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn color="success" @click="serviceSave()">Kaydet</v-btn>
                  </v-card-actions>
              </v-card>
              </v-flex>
            </v-flex>
            <v-flex xs8 pa-1 sm12 md3>
              <v-layout row wrap>
                <v-flex xs12 pb-2 sm12 md12>
                  <v-card flat="">
                    <v-layout pa-2 row wrap>
                      <v-flex xs12 pt-2 pb-2 sm12 md12>
                        <v-icon medium="" color="info">add_shopping_cart</v-icon>&nbsp;

                        <span class=" font-weight-regular grey--text title">{{$t('Products-Added')}}</span>
                      </v-flex>
                      <v-flex xs12 pt-2 pb-2 sm12 md12>
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12 pt-2 pb-2 v-if="itemsshop.length==0" sm12 md12><span
                          class=" font-weight-regular grey--text subheading">{{$t('Not-Added-Any-Products-Yet')}} !</span></v-flex>
                      <v-flex xs12 pt-2 pb-2 sm12 md12>
                        <v-list two-line subheader>
                          <v-list-tile v-for="item in itemsshop" :key="item.title" avatar>
                            <v-layout row wrap>
                              <v-flex xs6 sm6 md6>
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    {{ item.EkUrunAdi}}

                                  </v-list-tile-title>
                                  <v-list-tile-sub-title> {{item.EkUrunAdi +  $t('Automation') }}

                                  </v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-flex>
                              <v-flex pr-2 xs6 sm3 md5>
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    <v-layout justify-end="" fill-height="" row wrap> {{item.Tutar | moneyformat}}{{getparabirimi()}}

                                    </v-layout>
                                  </v-list-tile-title>
                                  <v-list-tile-sub-title>&nbsp;
                                  </v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-flex>
                              <v-flex pl-2 xs6 sm3 md1>
                                <v-list-tile-action>
                                  <v-layout align-start="" fill-height="" row wrap>
                                    <v-btn @click="sepetiSil(item)" icon ripple>
                                      <v-icon color="red">delete</v-icon>
                                    </v-btn>
                                  </v-layout>
                                </v-list-tile-action>
                              </v-flex>
                            </v-layout>
                          </v-list-tile>
                        </v-list>
                        <v-flex xs12 sm12>
                          <v-divider></v-divider>
                        </v-flex>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-list v-if="itemsshop.length>0" two-line subheader>
                          <v-list-tile avatar>
                            <v-layout row wrap>
                              <v-flex xs6 sm6 md6>
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ $t('Amount-to-be-Collected') }} : </v-list-tile-title>
                                  <v-list-tile-sub-title>&nbsp;

                                  </v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-flex>
                              <v-flex pr-2 xs6 sm3 md5>
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    <v-layout justify-end="" fill-height="" row wrap> {{genelToplam | moneyformat}}{{getparabirimi()}}

                                      </v-layout>
                                  </v-list-tile-title>
                                  <v-list-tile-sub-title>&nbsp;
                                  </v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-flex>
                            </v-layout>
                          </v-list-tile>
                        </v-list>
                        <v-flex xs12 pt-3 pb-2 sm12 md12>
                          <v-btn @click="odemeYapEkrani()" :disabled="!itemsshop.length>0" color="info" block="">
                            {{ $t('Make-Payment') }}  
                          </v-btn>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex v-if="odemeEkrani && itemsshop.length>0" xs12 pb-2 sm12 md12>
                  <v-card flat="">
                    <v-layout pa-2 row wrap>
                      <v-flex xs12 pt-2 pb-2 sm12 md12>
                        <v-icon medium="" color="info">payment</v-icon>&nbsp;
                        <span class=" font-weight-regular grey--text title"> {{ $t('Payment-Details') }} </span>
                      </v-flex>
                      <v-flex xs12 pt-2 pb-2 sm12 md12>
                        <v-divider></v-divider>
                      </v-flex>
                      <v-tabs style="width:100%;" dark="" v-model="active" color="blue darken-3" slot="extension"
                        slider->
                        <v-tabs-slider></v-tabs-slider>
                        <v-tab href='#0'>Kredİ Kartı </v-tab>
                        <v-tab-item :id="'0'" style="width:100%; ">
                          <v-layout row="" wrap="">
                            <v-form ref="formodeme" v-model="validOdeme" lazy-validation>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-text-field hide-details="" :rules="[v => !!v || $t('Please-enter-your-invoice-number')]"
                                    v-model="PaymentForm.CardNumber" :label="$t('Credit-Card-No')" mask="####-####-####-####">
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12></v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-text-field hide-details="" v-model="PaymentForm.CardHolder"
                                    :rules="[v => !!v || $t('Please-enter-your-invoice-number')]" :label="$t('Name-on-Card')">
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md6>
                                  <v-select :items="sonkullanimAy" :label="$t('Expiry-Month')"
                                    v-model="PaymentForm.ExpirationMonth"
                                    :rules="[v => !!v || $t('Please-enter-your-invoice-number')]" hide-details="" item-text="text"
                                    item-value="id"></v-select>
                                </v-flex>
                                <v-flex xs12 sm12 md6>
                                  <v-select :items="sonkullanimYil" v-model="PaymentForm.ExpirationYear"
                                    :label="$t('Expiry-Year')" hide-details=""
                                    :rules="[v => !!v || $t('Please-enter-your-invoice-number')]" item-text="text" item-value="id">
                                  </v-select>
                                </v-flex>
                                <v-flex xs12 sm12 md4>
                                  <v-text-field label="CVV" v-model="PaymentForm.Cvv"
                                    :rules="[v => !!v || $t('Please-enter-your-invoice-number')]" hide-details="" mask="###">
                                  </v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-form>
                          </v-layout>
                        </v-tab-item>
                        <v-tab href='#1'> {{ $t('Transfer-v3') }} </v-tab>
                        <v-tab-item :id="'1'" style="width:100%;">
                          <v-layout pt-2 row="" wrap=""><span class="grey--text body-2">* {{$t('Transfer-Confirmation-Confirm')}}
                              <span class="red--text font-weight-bold body-2">'' {{havalekodu}}

                                ''</span> 
                                {{$t('Transfer-Confirmation-Confirm-s2')}}
                                </span></v-layout>
                        </v-tab-item>
                      </v-tabs>
                      <v-flex xs12 pt-3 pb-2 sm12 md12>
                        <v-btn @click="OdemeOnayla()" color="info" block="">{{ $t('Approve') }}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{text1}}

            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>
          <v-dialog v-model="kurekledialog" persistent="" max-width="300px">
            <v-card flat color="grey lighten-5">
              <v-card-title>{{$t('Exchange-Entry')}}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm12 md12 pa-1>
                    <v-layout row="" wrap="">
                      <v-flex xs12 sm12 md12>
                        <dovizinput v-model="kurTutar" :etiket="$t('Exchange-Amount')" :autocomplete="'autocomplete'">
                        </dovizinput>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="kurekledialog=false">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click="kurKaydet()"> {{ $t('Save-Currency') }} </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>
<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import tool from "../coper/tools";
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
  import analizcomp from "@/components/app/bilet/partpage/analizcomp.vue"
  import dovizinput from '@/components/app/customcomp/dovizinput.vue'
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import loadingcomp from "@/components/app/customcomp/loadingcomp"
  import imgSrcThy from '@/assets/images/thy.png'
  import imgSrcajet from '@/assets/images/ajet.png'
  import imgSrcpegasus from '@/assets/images/pegasus.png' 
  import imgSrcairarabia from '@/assets/images/airarabia.png' 
  import imgSrcturnacom from '@/assets/images/turnacom.png' 
  import imgSrcaerticket from '@/assets/images/aerticket.png'
  import imgSrcaertuerk from '@/assets/images/aertuerk.png'
  import imgSrceasygds from '@/assets/images/easygds.png'
  import imgSrctamamliyocom from '@/assets/images/tamamliyocom.png'
  import imgSrcpaximum from '@/assets/images/paximum.png'
  import imgSrcratehawk from '@/assets/images/ratehawk.png'
  import imgSrcbiletbank from '@/assets/images/biletbank.png' 
  import imgSrcyolcu360 from '@/assets/images/yolcu360.png' 
  import imgSrcrentnconnect from '@/assets/images/rentnconnect.png'
  import imgSrcpaxdrive from '@/assets/images/paxdrive.png'
  import imgSrcuyumsoft from '@/assets/images/uyumsoft2025.png'
  import imgSrcelogo from '@/assets/images/elogo2025.png'
  import imgSrcveriban from '@/assets/images/veriban2025.png'
  import imgSrcedm from '@/assets/images/edm2025.png'
  import imgSrcdigitalplanet from '@/assets/images/digitalplanet2025.png'
  import imgSrcefinans from '@/assets/images/efinans2025.jpg'
  import imgSrcisnet from '@/assets/images/isnet2025.png'

  export default {

    data() {
      return {
        PB:'TRY',
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        show1:false,
        serviceShow:false,
        serviceData:{
          Id:0,
          CustomerID:0,
          IsTest:false,
          ServiceType:0,
          UserName:null,
          Password:null,
          Url:null,
        },
        loadingvmodel: false,
        havalekodu: null,
        efaturavarmi: false,
        earsivvarmi: false,
        edeftervarmi: false,

        UrunKayit: {
          ID: null,
          Aciklama: null,
          OdemeTip: '0', // 0 Havale 1 Kredi
          OdemeOnay: false,
          Tarih: null,
          Tutar: 0,
          Banka: null,
          TaksitAdet: null,
          VadeFarki: null,
          VadeTarihi: null,
          CariKod: null,
          FaturaTarihi: null,
          FaturaSeri: null,
          FaturaNo: null,
          IslemID: null,
          GuID: null,
          SiparisID: null,
          DekontID: null,
          UlkeID: null,
          MusteriID: null,
          MusteriKod: null,
          MusteriAdi: null,
        }

        ,

        EkUrunMusteri: {

          ID: null,
          EkUrunID: null,
          EkUrun: {
            EkUrunID: null,
            EkUrunGrupID: null,
            EkUrunAdi: null,
            EkUrunAciklama: null,
            EkUrunImage: null,
            EkUrunTutar: 0,
            Aktif: false
          }

          ,
          OdemeID: null,
          MusteriID: null,
          UserID: null,
          SatisTarihi: null,
          SatisTutari: null,
          OdemeOnay: null,
          Aktif: null
        }

        ,

        aktifEntegrator: null,
        entegratorShow: false,
        entegratorAyar: null,
        entegratorList: [],
        genelToplam: 0,
        odemeEkrani: false,
        karttipi: [{
            id: 'M',
            text: 'Master Card'
          }

          ,
          {
            id: 'VI',
            text: 'VISA'
          }

          ,
          {
            id: 'A',
            text: 'American Express'
          }

          ,
        ],
        sonkullanimAy: [{
            id: '01',
            text: '1'
          }

          ,
          {
            id: '02',
            text: '2'
          }

          ,
          {
            id: '03',
            text: '3'
          }

          ,
          {
            id: '04',
            text: '4'
          }

          ,
          {
            id: '05',
            text: '5'
          }

          ,
          {
            id: '06',
            text: '6'
          }

          ,
          {
            id: '07',
            text: '7'
          }

          ,
          {
            id: '08',
            text: '8'
          }

          ,
          {
            id: '09',
            text: '9'
          }

          ,
          {
            id: '10',
            text: '10'
          }

          ,
          {
            id: '11',
            text: '11'
          }

          ,
          {
            id: '12',
            text: '12'
          }

        ],
        sonkullanimYil: ['2019',
          '2020',
          '2021',
          '2022',
          '2023',
          '2024',
          '2025',
          '2026',
          '2027',
          '2028',
          '2029',
          '2030'

        ],
        validOdeme: true,
        PaymentForm: {
          Id: null,
          CardHolder: null,
          CardNumber: null,
          Cvv: null,
          ExpirationYear: null,
          ExpirationMonth: null,
          MobilePhone: null,
          VirtualPosId: null,
          InstallmentCount: null,
          Amount: 0,
          OkUrl: 'http://next.arkman.com.tr/#/odeme/basarili',
          FailUrl: 'localhost:8080/#/odeme/hata'
        }

        ,
        ekurunitems: [],
        kategori: [],
        itemsshop: [],
        aktifgrup: null,
        iconcolor: [],
        urunler: [],

        entegratorler: [{
            Tip: 1,
            EkUrunGrupID: 1,
            EkUrunID: 1,
            name: 'UyumSoft',
            urunAdi: 'Uyum Soft',
            imgLink: imgSrcuyumsoft
          }

          ,
          {
            Tip: 1,
            EkUrunGrupID: 1,
            EkUrunID: 2,
            name: 'Logo',
            urunAdi: 'Logo',
            imgLink: imgSrcelogo
          }

          ,
          {
            Tip: 1,
            EkUrunGrupID: 1,
            EkUrunID: 3,
            name: 'Veriban',
            urunAdi: 'Veriban',
            imgLink: imgSrcveriban
          },
          {
            Tip: 1,
            EkUrunGrupID: 1,
            EkUrunID: 3,
            name: 'DigitalPlanet',
            urunAdi: 'Digital Planet',
            imgLink: imgSrcdigitalplanet
          }

          ,
          {
            Tip: 1,
            EkUrunGrupID: 1,
            EkUrunID: 4,
            name: 'EFinans',
            urunAdi: 'E-Finans',
            imgLink: imgSrcefinans
          },
          {
            Tip: 1,
            EkUrunGrupID: 1,
            EkUrunID: 5,
            name: 'EDM',
            urunAdi: 'E-Dönüşüm Merkezi',
            imgLink: imgSrcedm
          },
            {
            Tip: 1,
            EkUrunGrupID: 1,
            EkUrunID: 6,
            name: 'Isnet',
            urunAdi: 'İşNet',
            imgLink: imgSrcisnet
          },
          {
            Tip: 3,
            EkUrunGrupID: 3,
            EkUrunID: 3,
            name: 'EFinans',
            urunAdi: 'E-Finans',
            imgLink: imgSrcefinans
          },
          {
            Tip: 2,
            EkUrunGrupID: 2,
            EkUrunID: 1,
            name: 'UyumSoft',
            urunAdi: 'Uyum Soft',
            imgLink: imgSrcuyumsoft
          },
          {
            Tip: 2,
            EkUrunGrupID: 2,
            EkUrunID: 6,
            name: 'DigitalPlanet',
            urunAdi: 'Digital Planet',
            imgLink: imgSrcdigitalplanet
          },
          {
            Tip: 2,
            EkUrunGrupID: 2,
            EkUrunID: 2,
            name: 'Logo',
            urunAdi: 'Logo',
            imgLink: imgSrcelogo
          },
          {
            Tip: 2,
            EkUrunGrupID: 2,
            EkUrunID: 3,
            name: 'Veriban',
            urunAdi: 'Veriban',
            imgLink: imgSrcveriban
          },
          {
            Tip: 2,
            EkUrunGrupID: 2,
            EkUrunID: 4,
            name: 'EFinans',
            urunAdi: 'E-Finans',
            imgLink: imgSrcefinans
          },
          {
            Tip: 2,
            EkUrunGrupID: 2,
            EkUrunID: 5,
            name: 'EDM',
            urunAdi: 'E-Dönüşüm Merkezi',
            imgLink: imgSrcedm
          },
          {
            Tip: 2,
            EkUrunGrupID: 2,
            EkUrunID: 6,
            name: 'Isnet',
            urunAdi: 'İşNet',
            imgLink: imgSrcisnet
          },
          // {
          //   Tip: 4,
          //   EkUrunGrupID: 4,
          //   EkUrunID: 1,
          //   name: 'SMBLTR',
          //   urunAdi: 'Sem Bilet',
          //   imgLink: 'https://scontent.fist7-2.fna.fbcdn.net/v/t39.30808-6/306000688_171213095493802_5456016573010928586_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=OwekCe7-PXgQ7kNvgGKK4Pf&_nc_oc=AdkGslsD-w321J0q4C7K8Z7SaJA5oBrhDIgKz3HrnfPdD7cOyfFPf4T6rj7rn4_yQNg&_nc_zt=23&_nc_ht=scontent.fist7-2.fna&_nc_gid=TrDyXZk7lNFFGJOByFdtow&oh=00_AYF2aG773_373IIKeJGKB5VqYdC8GurmbJCoFS3a6b5QPQ&oe=67F449C9'
          // },
          // {
          //   Tip: 4,
          //   EkUrunGrupID: 4,
          //   EkUrunID: 2,
          //   name: 'HTLRNNR',
          //   urunAdi: 'Hotel Runner',
          //   imgLink: 'https://play-lh.googleusercontent.com/DB54yYqlWuy6x4WlYD7JN--88GboewVOMLBzh2HYmfm47wTqSPWI20YIWwobcFSJaJ4=w480-h960-rw'
          // },
          // {
          //   Tip: 4,
          //   EkUrunGrupID: 4,
          //   EkUrunID: 3,
          //   name: 'PXDRV',
          //   urunAdi: 'Pax Drive',
          //   imgLink: 'https://media-exp2.licdn.com/dms/image/C560BAQFdjD0dOPREZg/company-logo_200_200/0/1519311045862?e=2147483647&v=beta&t=lzDLlTOk9m6UqEd19Fmf7jYnRD3wPCQs-AX71FChvV0'
          // },
           {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'thypazar',
            urunAdi: 'THY',
            imgLink: imgSrcThy
          },
          {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'ajetpazar',
            urunAdi: 'AJET',
            imgLink: imgSrcajet
          },
          {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'pegasuspazar',
            urunAdi: 'PEGASUS',
            imgLink: imgSrcpegasus
          },
          {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'airarabiapazar',
            urunAdi: 'AIR ARABIA',
            imgLink: imgSrcairarabia
          },
          {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'turnacompazar',
            urunAdi: 'TURNA.COM',
            imgLink: imgSrcturnacom
          },
          {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'airtuerkpazar',
            urunAdi: 'AERTICKET',
            imgLink: imgSrcaerticket
          },
          {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'airtuerkpazar',
            urunAdi: 'AIRTUERK ',
            imgLink: imgSrcaertuerk
          },
          {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'easygdspazar',
            urunAdi: 'EASYGDS )',
            imgLink: imgSrceasygds
          },
          {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'paximumpazar',
            urunAdi: 'PAXIMUM ',
            imgLink: imgSrcpaximum
          },
          {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'ratehawkpazar',
            urunAdi: 'RATEHAWK',
            imgLink: imgSrcratehawk
          },
          {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'biletpankpazar',
            urunAdi: 'BILETBANK',
            imgLink: imgSrcbiletbank
          },
          {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'yolcu360pazar',
            urunAdi: 'YOLCU360',
            imgLink: imgSrcyolcu360
          },
          {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'paxdrivepazar',
            urunAdi: 'PAXDRIVE ',
            imgLink: imgSrcpaxdrive
          },
          {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'rentconnectpazar',
            urunAdi: 'RENT & CONNECT',
            imgLink: imgSrcrentnconnect
          },
          {
            Tip: 4,
            EkUrunGrupID: 4,
            EkUrunID: 1,
            name: 'tamamliyocompazar',
            urunAdi: 'TAMAMLIYO.COM',
            imgLink: imgSrctamamliyocom
          },
        ],

        odemeislem: false,
        kayitislem: false,
        kurekledialog: false,
        kurTutar: 0,
        duzenlenenindex: -1,
        progress: false,
        recordcount: 50,
        listtype: '0',
        hesapitems: [],
        masrafitems: [],
        referansitems: [],
        evraktipi: [],
        search: '',
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,
        active: null,

        Rapor: {
          BaslangicTarih: null,
          BitisTarih: null,
          DovizTip: null,
        }

        ,

        valid: true,
        tumsirketler: '',

        loading: false,
        loading1: false,

        items1: [],
        load: false,
        load1: true,
        search3: '',


        itemssatis: [],

        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {
            tarihsec: {
              required: () =>this.$t('Please-select-a-date')
            }

            ,
            tarihsec1: {
              required: () =>this.$t('Please-select-a-date')
            }

            ,
          }
        }

        ,
      }
    }

    ,
    beforeRouteEnter(to, from, next) {
      next(vm => {
          vm.prevRoute = from.path
        }

      )
    }

    ,
    beforeMount: beforeMount,

    mounted() {
      this.$validator.localize('en', this.dictionary)
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.PB=credentials.ParaBirimi;
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      if (this.sayfayetki.Status == true) {

        var params3 = {
          GrupID: null,
          UrunID: null,
          MusteriID: null
        }

        this.$http.post(auth.API_URL + 'api/Awed/ExtraProductGroupList', params3, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }

        ).then((response) => {

          console.log( response.body);
            this.ekurunitems = response.body
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var params4 = {
              GrupID: null,
              UrunID: null,
              MusteriID: credentials.MusteriID
            }

            this.$http.post(auth.API_URL + 'api/Awed/ExtraProductCustomerList', params4, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
              }

            ).then((response) => {  
                if (this.ekurunitems.length > 0) {
                  var ProductList = []

                  this.ekurunitems.forEach(element => {

                      var id = response.body.map(function (e) {
                          return e.EkUrunID;
                        }

                      ).indexOf(element.EkUrunGrupID);

                      if (id != -1) {

                        if (element.EkUrunGrupID == 1 ) {
                          this.efaturavarmi = true
                        }

                        if (element.EkUrunGrupID == 2) {
                          this.earsivvarmi = true
                        }


                        if (element.EkUrunGrupID == 3) {
                          this.edeftervarmi = true
                        }




                        var urunMusteri = {
                          Aktif: response.body[id].Aktif,
                          EkUrunID: response.body[id].EkUrunID,
                          ID: response.body[id].ID,
                          MusteriID: response.body[id].MusteriID,
                          OdemeOnay: response.body[id].OdemeOnay,
                          SatisTarihi: response.body[id].SatisTarihi,
                          SatisTutari: response.body[id].SatisTutari,
                          UserID: response.body[id].UserID
                        }
                      } else {
                        var urunMusteri = {
                          Aktif: false,
                          EkUrunID: null,
                          ID: null,
                          MusteriID: null,
                          OdemeOnay: null,
                          SatisTarihi: null,
                          SatisTutari: 0,
                          UserID: null,
                        }
                      }

                      //şuan 0 indexli elemanlar için düzenlenmiş kod
                      var alturunlist = [];

                      var alturun = {
                        Aktif: element.Urunler[0].Aktif,
                        Tutar: element.Urunler[0].EkUrunTutar,
                        EkUrunAciklama: element.Urunler[0].EkUrunAciklama,
                        EkUrunAdi: element.Urunler[0].EkUrunAdi,
                        EkUrunGrupID: element.Urunler[0].EkUrunGrupID,
                        EkUrunID: element.Urunler[0].EkUrunID,
                        EkUrunImage: element.Urunler[0].EkUrunImage,
                        urunMusteri: urunMusteri
                      }

                      alturunlist.push(alturun)
                      var yenikayit = {
                        Aktif: element.Aktif,
                        EkUrunGrupAdi: element.EkUrunGrupAdi,
                        EkUrunGrupID: element.EkUrunGrupID,
                        Urunler: alturunlist
                      }
                      if (this.PB=="TRY")
{
  ProductList.push(yenikayit);
}
else
{
  if (yenikayit.EkUrunGrupAdi=="Pazar Yerı")
  {
    yenikayit.EkUrunGrupAdi=this.$t('MarketPlace');
    ProductList.push(yenikayit);
  }
}
                      

                    }

                  );
                  this.ekurunitems = ProductList
                }

              }

              , (response) => {
                if (response.status === 0) {
                  this.text1 = 'Service Unavailable-ExtraProductCustomerList'
                  this.snackbar = true
                } else {
                  this.text1 = 'Service Unavailable-ExtraProductCustomerList'
                  this.snackbar = true
                }
              }

            )
          }

          , (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-ExtraProductCustomerList'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-ExtraProductCustomerList'
              this.snackbar = true
            }
          }

        )
      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

            if (sonuc == true) {

              if (this.prevRoute != null) {
                var url = '#' + this.prevRoute
                window.open(url, '_self')
              } else {
                var url = '#/'
                window.open(url, '_self')
              }
            } else {}

          }

        );

      }
    }

    ,
    filters: {
      yuzdekontrol: function (y) {

          if (y == Infinity || isNaN(y) == true) {
            return '-'
          } else {
            var a = String(Number((y).toFixed(2)));
            return a.replace("-", "")
          }
        }

        ,

      dateformat: function (t) {
          return helpers.dateformat(t);
        }

        ,
      currencyformat: function (t) {
          return helpers.currencyformat(t);
        }

        ,
      moneyformat: function (m) {
          return helpers.moneyformat(m);
        }

        ,

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    }

    ,

    components: {
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      analizcomp,
      havayollaricomp,
      dovizinput,
      yetkidialog,
      loadingcomp
    }

    ,
    watch: {}

    ,
    methods: {
      serviceSave(){
        this.loadingvmodel = true;
        var credentials = JSON.parse(window.localStorage.getItem("credentials"));

        this.serviceData.CustomerID = credentials.MusteriID;

        this.$http.post(auth.API_URL + 'api/Booking/ServiceInfoSave', this.serviceData, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }
        ).then((response) => {
           this.text1 = this.$t(response.body.ResponseMessage);
          this.snackbar = true
          this.loadingvmodel = false;
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.loadingvmodel = false;
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.loadingvmodel = false;
              this.snackbar = true
            }
          }
        )
      },
      getparabirimi() {
        return helpers.getparabirimi()
      },
      OdemeOnayla() {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var odemeislem = false
        var kayitislem = false
        this.itemsshop.forEach(element => {

            this.UrunKayit.Tarih = this.getDateNow()
            this.UrunKayit.OdemeOnay = false
            this.UrunKayit.Aciklama = this.havalekodu
            this.UrunKayit.OdemeTip = '0'
            this.UrunKayit.Tutar = element.Tutar
            this.UrunKayit.MusteriID = credentials.MusteriID
            this.UrunKayit.MusteriKod = credentials.AnaSirketKodu

            var params = this.UrunKayit

            this.$http.post(auth.API_URL + 'api/Register/PackageCustomerPaymentSave', params, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
              }

            ).then((response) => {

                if (response.body.Status == true) {
                  this.odemeislem = true

                  if (response.body.SaveID != null && response.body.SaveID != '') {
                    this.EkUrunMusteri.OdemeID = response.body.SaveID;
                    this.EkUrunMusteri.SatisTarihi = this.getDateNow();
                    this.EkUrunMusteri.OdemeOnay = false;
                    this.EkUrunMusteri.MusteriID = credentials.MusteriID;
                    this.EkUrunMusteri.Aktif = true;
                    this.EkUrunMusteri.UserID = credentials.UserID
                    this.EkUrunMusteri.SatisTutari = element.Tutar
                    this.EkUrunMusteri.EkUrunID = element.EkUrunID

                    var params = this.EkUrunMusteri
                    this.$http.post(auth.API_URL + 'api/Awed/ExtraProductCustomerSave', params, {
                        headers: {
                          'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                      }

                    ).then((response) => {

                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true

                        if (response.body.Status == true) {

                          this.kayitislem = true
                        } else {

                          this.kayitislem = false
                        }

                      }

                      , (response) => {
                        if (response.status === 0) {
                          this.text1 = 'Service Unavailable-ExtraProductCustomerSave'
                          this.snackbar = true
                        } else {
                          this.text1 = 'Service Unavailable-ExtraProductCustomerSave'
                          this.snackbar = true
                        }
                      }

                    )
                  } else {
                    this.text1 =this.$t('Payment-registration-process-is-completed-The-product-could-not-be-introduced-to-your-user-Please-contact-the-support-team.')
                     
                    this.snackbar = true
                  }

                } else {


                  this.odemeislem = false
                   this.text1 = this.$t(response.body.ResponseMessage)
                  this.snackbar = true
                }


              }

              , (response) => {
                if (response.status === 0) {
                  this.text1 = 'Service Unavailable-ProductCustomerSave'
                  this.snackbar = true
                } else {
                  this.text1 = 'Service Unavailable-ProductCustomerSave'
                  this.snackbar = true
                }
              }

            )
          }

        );


        this.loadingvmodel = true
        setTimeout(function () {
            var url = '#/urunler/ekurunler/'
            window.open(url, '_self')
            window.location.reload(false);

          }

          .bind(this), 3500)


      }

      ,
      entegratorAyarKaydet() {


        var prm = {
          ayar: this.entegratorAyar,
          tip: this.aktifgrup
        }




        tool.api_post(this, "EFatura/EntegratorAyarlariKaydet", prm).then(response => {

            if (response.body == true) {
              this.text1 =this.$t('Edited')
              this.snackbar = true
            } else {
              this.text1 =this.$t('Unsuccessful')
              this.snackbar = true
            }

          }

          ,
          response => {
            this.status = tool.responseToStatus(response);
          }

        );
      }

      ,
      getDateNow() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();

        if (dd < 10) {
          dd = '0' + dd
        }

        if (mm < 10) {
          mm = '0' + mm
        }

        today = yyyy + '-' + mm + '-' + dd
        return today
      }

      ,
      entegratorChange() {
        this.ayar = this.entegratorList[this.entegrator];
      },
      entegratorAyarla(val, tip) {
       
          if(tip != 4){
        var prm = {
          tip: this.aktifgrup,
        }

        tool.api_post(this, "EFatura/EntegratorAyarlari", prm).then(response => {
            if (response.body != null) {
              var str = response.body.EntClassName;
              var str1 = str.split('.');
 
              if (str1[1] == val.name) {
                var str = response.body.EntClassName;
                var str1 = str.split('.');



                this.entegratorAyar = response.body
                this.entegratorShow = true
              } else {
                var sonucvarmi = false
                Object.keys(this.entegratorList).forEach(key => {

                    if (tip == 1) {
        
                      if (val.name == key) {
                   
                        sonucvarmi = true
                        this.entegratorAyar = this.entegratorList[key]
                        this.entegratorShow = true
                       
                      }
                    } else if (tip == 2) {
                      if (val.name + 'Arsiv' == key) {
                        sonucvarmi = true
                        this.entegratorAyar = this.entegratorList[key]
                        this.entegratorShow = true
                      }
                    }

                  }

                );

                if (sonucvarmi == false) {
                  this.text1 =this.$t('No-Integrator-setting-has-been-found')
                  this.snackbar = true
                  this.entegratorShow = false
                }

              }

            } else {


              var sonuc = false
              Object.keys(this.entegratorList).forEach(key => {

                  if (tip == '2') {

                    var deger1 = val.name + 'Arsiv'
                    var deger2 = key + 'Arsiv'

                    if (deger1 == key) {
                      sonuc = true
                      this.entegratorShow = true
                      this.entegratorAyar = this.entegratorList[key]
                    }
                  }

                  if (tip == 1) {
                    if (val.name == key) {
                      sonuc = true
                      this.entegratorShow = true
                      this.entegratorAyar = this.entegratorList[key]
                    }

                  }

                }

              );

              if (sonuc == false) {
                this.text1 = this.$t('No-settings-found')
                this.snackbar = true
                this.entegratorShow = false
              }


            }


          }

          ,
          response => {
            this.status = tool.responseToStatus(response);
          }

        );
        }else{

       
          this.serviceData.ServiceType = val.EkUrunID;

        var credentials = JSON.parse(window.localStorage.getItem("credentials"));

        var params = {
          CustomerID : credentials.MusteriID,
          ServiceID : val.EkUrunID
        };

        this.$http.post(auth.API_URL + 'api/Booking/ServiceInfoLoad', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }
        ).then((response) => {
 
          this.serviceShow = true;
          this.serviceData = response.body;


          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.progress = false
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.progress = false
              this.snackbar = true
            }
          }
        )
        }
      

      }

      ,
      defaultKod(length) {

        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var charactersLength = characters.length;

        for (var i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
          const rnd = Math.floor(Math.random() * 90000) + 10000;
          return result + rnd;
        }
      }

      ,
      odemeYapEkrani() {
        this.odemeEkrani = !this.odemeEkrani
        this.havalekodu = this.defaultKod(8)
      }

      ,
      getdegeral(a) {
        return a.urunMusteri.Aktif
      }

      ,

      sepetiSil(val) {
        var id = this.itemsshop.map(function (e) {
            return e.EkUrunID;
          }

        ).indexOf(val.EkUrunGrupID);

        if (id > -1) {
          this.itemsshop.splice(id, 1);
        }

        this.genelToplam = 0;

        this.itemsshop.forEach(element => {
            this.genelToplam = this.genelToplam + element.Tutar
          }

        );

      }

      ,
      sepeteEkle(val) {
        var id = this.itemsshop.map(function (e) {
            return e.EkUrunID;
          }

        ).indexOf(val.EkUrunGrupID);

        if (id == -1) {
          this.itemsshop.push(val);
          this.genelToplam = 0;

          this.itemsshop.forEach(element => {
              this.genelToplam = this.genelToplam + element.Tutar
            }

          );
        } else {
          this.text1 = this.$t('The-product-was-added-before.')
          this.snackbar = true
        }
      }

      ,
      kurKaydet() {
        var list = []
        var params = {
          Tarih: this.itemssatis[this.duzenlenenindex].Tarih,
          DovizKod: this.itemssatis[this.duzenlenenindex].DovizKod,
          KurTutar: this.kurTutar
        }

        list.push(params)

        this.$http.post(auth.API_URL + 'api/Definitions/CurrencyRateSave', list, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }

        ).then((response) => {

             this.text1 = this.$t(response.body.ResponseMessage);

            this.snackbar = true
            if (response.body.Status === true) {
              this.kurekledialog = false
              for (var i = 0; i < this.itemssatis.length; i++) {

                if (this.duzenlenenindex == i) {
                  this.itemssatis[i].KurTutar = this.kurTutar
                }
              }


            }


          }

          , (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.progress = false
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.progress = false
              this.snackbar = true
            }
          }

        )
      }

      ,
      duzenle(val) {
        
        this.aktifgrup = val.EkUrunGrupID
        this.urunler = val.Urunler
        this.entegratorShow = false
        if(val.EkUrunGrupID != 4){
          this.AyarGoster(val.EkUrunGrupID);  
        }
        
      }

      ,

      kayitgoster() {
        this.recordcount = this.recordcount + 50;

        this.itemssatis = this.itemssatisview.slice(0, this.recordcount)
        if (this.listtype == 1) {

        }
      },
      getList: getList,
      GetEntegratorList: GetEntegratorList,
      AyarGoster: AyarGoster
    }

  }

  function AyarGoster(tip) {
    var prm = {
      tip: tip,
    }

    ;

    // this.entegrator = null;
    this.GetEntegratorList();

    tool.api_post(this, "EFatura/EntegratorAyarlari", prm).then(response => {

        var str = response.body.EntClassName;
        var str1 = str.split('.');

       
        if (tip == 1 && this.efaturavarmi == true) {
          this.aktifEntegrator = str1[1]
        } else if (tip == 2 && this.earsivvarmi == true) {
          this.aktifEntegrator = str1[1]
        } else if (tip == 3 && this.edeftervarmi == true) {
          this.aktifEntegrator = str1[1]
        } else {
          this.aktifEntegrator = null
        }




      }

      ,
      response => {
        this.status = tool.responseToStatus(response);
      }

    );


  }

  function GetEntegratorList() {
    var prm = {
      tip: this.aktifgrup, //1 efatura - 2 earşiv - 3 e defter
    }

    ;
    
    tool.api_post(this, "EFatura/EntegratorDefValue", prm).then(response => {


        this.entegratorList = response.body;

      }

      ,
      response => {
        this.status = tool.responseToStatus(response);
      }

    );

  }

  function getList() {

    if (this.$refs.formkur.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih) // if (bastarih <= bittarih) {

      this.progress = true
      this.load1 = false
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));


      var params = this.Rapor
      this.$http.post(auth.API_URL + 'api/Definitions/CurrencyRateList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }

      ).then((response) => {
          //  this.recordcount = 50

          //this.itemssatisview = response.body.DetayList

          this.itemssatis = response.body //this.itemssatisview.slice(0, this.recordcount)



          this.progress = false
          this.load1 = true
        }

        , (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        }

      ) // } else {
      //   this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
      //   this.snackbar = true
      // }
    }
  }

  function beforeMount() {}
</script>
<style>
  .urun {
    margin: 50px auto;
    width: 150px;
    height: 80px;
    background: #DDD;
    -webkit-box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    position: relative;
    z-index: 90;
  }

  .kurdele-alani {
    width: 85px;
    height: 88px;
    overflow: hidden;
    position: absolute;
    top: -3px;
    right: -3px;
  }

  .kurdele {
    font: 13px Sans-Serif;
    color: rgb(255, 255, 255);
    text-align: center;
    text-shadow: rgba(255, 255, 255, 0.5) 0px 1px 0px;
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    position: relative;
    padding: 7px 0;
    left: -5px;
    top: 15px;
    width: 120px;
    background-color: #2196F3;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#BFDC7A), to(#8EBF45));
    background-image: -webkit-linear-gradient(top, #BFDC7A, #8EBF45);
    background-image: -moz-linear-gradient(top, #BFDC7A, #8EBF45);
    background-image: -ms-linear-gradient(top, #BFDC7A, #8EBF45);
    background-image: -o-linear-gradient(top, #BFDC7A, #8EBF45);
    -webkit-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
  }

  .kurdele:before,
  .kurdele:after {
    content: "";
    border-top: 3px solid #6e8900;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    position: absolute;
    bottom: -3px;
  }

  .kurdele:before {
    left: 0;
  }

  .kurdele:after {
    right: 0;
  }
</style>